







































































import {
  IInventoryAdvancePayment,
  InventoryAdvancePaymentApprovalState
} from '@/models';
import Vue, { PropType } from 'vue';
import moment from 'moment';

export default Vue.extend({
  name: 'InventoryAdvancePaymentApproverListMenu',

  props: {
    inventoryAdvancePayment: {
      type: Object as PropType<IInventoryAdvancePayment>,
      required: true
    }
  },

  methods: {
    moment,

    getApproverStatusColor(status: InventoryAdvancePaymentApprovalState) {
      switch (status) {
        case InventoryAdvancePaymentApprovalState.TENTATIVE:
          return 'warning';
        case InventoryAdvancePaymentApprovalState.APPROVED:
          return 'success darken-1';
        case InventoryAdvancePaymentApprovalState.REJECTED:
          return 'error';
      }
    },

    getApproverStatusIcon(status: InventoryAdvancePaymentApprovalState) {
      switch (status) {
        case InventoryAdvancePaymentApprovalState.TENTATIVE:
          return 'mdi-account-alert-outline';
        case InventoryAdvancePaymentApprovalState.APPROVED:
          return 'mdi-account-check-outline';
        case InventoryAdvancePaymentApprovalState.REJECTED:
          return 'mdi-account-cancel-outline';
      }
    },

    getApproverStatusText(status: InventoryAdvancePaymentApprovalState) {
      switch (status) {
        case InventoryAdvancePaymentApprovalState.TENTATIVE:
          return 'Approval Pending';
        case InventoryAdvancePaymentApprovalState.APPROVED:
          return 'Approved';
        case InventoryAdvancePaymentApprovalState.REJECTED:
          return 'Rejected';
      }
    }
  }
});
